import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["align", "noWrap", "emptyValue", "formatter", "header", "label", "headerCellComponent", "headerCellComponentProps", "bodyCellComponent", "bodyCellComponentProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from "prop-types";
import React from "react";
import { resultOf } from "../../common/utilities";
import { EXPANDABLE_COLUMN_KEY } from "../../Table/constants";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function TableBodyCell(props) {
  const {
    columnKey: key,
    item,
    itemKey,
    className,
    column,
    style,
    // eslint-disable-line no-unused-vars
    itemIndex,
    tabIndex,
    // eslint-disable-line react/prop-types
    id,
    onKeyDown,
    onClick,
    // eslint-disable-line react/prop-types
    isSelected // eslint-disable-line react/prop-types

  } = props;

  const {
    align,
    // eslint-disable-line no-unused-vars
    noWrap,
    // eslint-disable-line no-unused-vars
    emptyValue,
    formatter,
    header,
    // eslint-disable-line no-unused-vars
    label,
    // eslint-disable-line no-unused-vars
    headerCellComponent,
    // eslint-disable-line no-unused-vars, react/prop-types
    headerCellComponentProps,
    // eslint-disable-line no-unused-vars, react/prop-types
    bodyCellComponent: TD = "td",
    bodyCellComponentProps
  } = column,
        others = _objectWithoutProperties(column, _excluded);

  let cellContent = item[key];

  if (formatter) {
    cellContent = formatter({
      cellContent,
      item,
      itemKey,
      itemIndex,
      selected: isSelected
    });
  }
  /**
   * Per spec, when button appears in the table, update table cell's `top` and `bottom` padding.
   */


  const cellData = typeof cellContent === "undefined" && emptyValue ? resultOf(emptyValue, item) : cellContent;
  const isActionableCell = cellData && cellData.props && (cellData.props.onClick || cellData.props.onValueChange);
  return _jsx(TD // eslint-disable-next-line react/prop-types
  , _objectSpread(_objectSpread(_objectSpread({
    "aria-describedby": headerCellComponentProps === null || headerCellComponentProps === void 0 ? void 0 : headerCellComponentProps.id,
    tabIndex: tabIndex,
    id: id,
    onKeyDown: onKeyDown,
    onClick: onClick
  }, others), bodyCellComponentProps), {}, {
    item: typeof TD === "function" ? item : null,
    className: className,
    children: isSelected && !isActionableCell && key !== EXPANDABLE_COLUMN_KEY ? _jsx("div", {
      // Text role added for iOS VO to prevent splitting of cell data and hidden message.
      // eslint-disable-next-line jsx-a11y/aria-role
      role: "text",
      children: _jsxs("div", {
        children: [cellData, _jsx("span", {
          className: "wf-u-visually-hidden",
          children: ", selected"
        })]
      })
    }) : cellData
  }));
} // eslint-disable-next-line react/prefer-stateless-function


TableBodyCell.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The current column */
  column: PropTypes.shape({
    /** The key to locate the value for the column inside each record. */
    key: PropTypes.string.isRequired,

    /**
     * The display label for the header or column information.
     * Overridden by `columns.header` prop.
     */
    label: PropTypes.string,

    /**
     * The header content for the column.
     * Overrides `columns.label` prop.
     * One of type: `string`, `func`.
     */
    header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

    /**
     * The alignment of column's cells. Can be `left`, `center` or `right`.
     * Defaults to `left`.
     */
    align: PropTypes.oneOf(["left", "center", "right"]),

    /** Additional class name added to the header and body cells. */
    className: PropTypes.string,

    /** Describes whether the text content should not wrap. Default to `false`. */
    noWrap: PropTypes.bool,

    /** Additional styles for the header cell. */
    style: PropTypes.object,
    // eslint-disable-line react/forbid-prop-types

    /** The content of the cell to use when the record value is empty. */
    emptyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),

    /**
     * A function that will return a formatted version of the columns data.
     * It will receive one object argument with `cellContent`, `item`, `itemIndex`,
     * `itemKey`, and `selected`.
     */
    formatter: PropTypes.func,

    /** The Component that renders the body cell */
    bodyCellComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

    /** The extra props passed to the bodyCellComponent */
    bodyCellComponentProps: PropTypes.object // eslint-disable-line react/forbid-prop-types

  }).isRequired,

  /** The columnKey to locate the record */
  columnKey: PropTypes.string.isRequired,

  /** The item data to render */
  item: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** The items's position in the dataset */
  itemIndex: PropTypes.number.isRequired,
  itemKey: PropTypes.node.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Additional class names separated by a space to add to the `<TH>` */
  className: PropTypes.string,

  /** Additional styles for `<TH>` */
  style: PropTypes.object // eslint-disable-line react/forbid-prop-types

} : {};
TableBodyCell.defaultProps = {
  className: "",
  style: null
};
export default TableBodyCell;